import React from 'react';
import { useParams } from 'react-router-dom';
import Alert from 'Components/Alert';
import DescriptionList from 'Components/DescriptionList/DescriptionList';
import DescriptionListItem from 'Components/DescriptionList/DescriptionListItem';
import FieldSet from 'Components/FieldSet';
import LoadingIndicator from 'Components/Loading/LoadingIndicator';
import PageContent from 'Components/Page/PageContent';
import PageContentBody from 'Components/Page/PageContentBody';
import PageToolbar from 'Components/Page/Toolbar/PageToolbar';
import PageToolbarButton from 'Components/Page/Toolbar/PageToolbarButton';
import PageToolbarSection from 'Components/Page/Toolbar/PageToolbarSection';
import { align, icons, kinds } from 'Helpers/Props';
import { formatDate, titleCase } from '../format';
import { useTdarrJobReport } from '../queries';

export default function ReportViewer() {
  const { jobFileId: encodedJobFileId } = useParams<{ jobFileId: string }>();
  const jobFileId = decodeURIComponent(encodedJobFileId);
  const parts = jobFileId.replace(/\.txt$/, '').split('()');
  const valid = parts.length === 5;
  const report = useTdarrJobReport(jobFileId);
  const title = valid ? `${titleCase(parts[2])} Report` : 'Job Report';
  return <PageContent title={title}>
    <PageToolbar><PageToolbarSection alignContent={align.LEFT}><PageToolbarButton label="Refresh" iconName={icons.REFRESH} isSpinning={report.isFetching} isDisabled={!valid} onPress={() => report.refetch()} /></PageToolbarSection></PageToolbar>
    <PageContentBody>
      {!valid && <Alert kind={kinds.DANGER}>The report identifier is invalid.</Alert>}
      {report.isPending && valid && <LoadingIndicator />}
      {report.isError && <Alert kind={kinds.DANGER}>The job report could not be loaded.</Alert>}
      {report.data && !report.data.jobReportExists && <Alert kind={kinds.WARNING}>The job report no longer exists.</Alert>}
      {report.data?.isJobRunning && <Alert kind={kinds.INFO}>This job is still running. The report refreshes automatically.</Alert>}
      {valid && <FieldSet legend="Job Details"><DescriptionList>
        <DescriptionListItem title="Footprint" data={parts[0]} /><DescriptionListItem title="Version" data={parts[1]} />
        <DescriptionListItem title="Job Type" data={titleCase(parts[2])} /><DescriptionListItem title="Job ID" data={parts[3]} />
        <DescriptionListItem title="Started" data={formatDate(Number(parts[4]))} />
      </DescriptionList></FieldSet>}
      {report.data?.text && <FieldSet legend="Job Report"><pre className="tdarr-log">{report.data.text}</pre></FieldSet>}
    </PageContentBody>
  </PageContent>;
}
